<h5 class="modal-title">Forgot Password</h5><hr>
<mat-dialog-content>
  <div class="modal-body">
    <form class="row" [formGroup]="forgotPasswordForm" (ngSubmit)="sendEmailNotification()">
      <div>Enter your email to reset your password</div>
      <input type="email" class="form-control" placeholder="Email" formControlName="email">
      <small class="text-danger" *ngIf="email?.invalid && email?.touched">
        <span *ngIf="email?.errors?.required">Email is required.</span>
        <span *ngIf="email?.errors?.pattern">Invalid email format.</span>
      </small>
    </form>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end" class="mat-dialog-actions">
  <button mat-dialog-close type="button" class="btn btn-secondary" (click)="close()">Close</button>
  <button type="button" class="btn btn-primary ml-2"
          [disabled]="isSending" (click)="sendEmailNotification()">
    <i *ngIf="isSending" class="fa fa-spinner fa-spin"></i> Send</button>
</mat-dialog-actions>
